import classNames from "classnames";
import { FunctionComponent, ReactElement } from "react";
import styles from "./NoTransactions.module.scss";
import { ReactComponent as NoTransactionsSvg } from "./_assets/no-transactions.svg";
import { INoTransactionsProps } from "./types";

export const NoTransactions: FunctionComponent<INoTransactionsProps> = (
  props: INoTransactionsProps
): ReactElement<INoTransactionsProps> => {
  const { className, ...restProps } = props;

  return (
    <div
      className={classNames(styles.containerDefault, className)}
      {...restProps}
    >
      <NoTransactionsSvg />
      <span className={styles.headerDefault}>Операций нет</span>
      <span className={styles.descriptionDefault}>
        Вы еще не создали ни одной операции
      </span>
    </div>
  );
};
